// extracted by css-extract-rspack-plugin
export default {"ResourceListItem":"GoD8Y"};